import { validPassword } from "consts";
import * as yup from "yup";

// Defaults

const PasswordSchema = yup
  .string()
  .required("errors.required")
  .matches(validPassword, "errors.invalidPassword");

const RequiredSchema = yup.string().required("errors.required");

// Exports

export const NewPasswordSchema = yup.object().shape({
  password: RequiredSchema,
  newPassword: PasswordSchema,
  confirmPassword: RequiredSchema.oneOf(
    [yup.ref("newPassword"), ""],
    "errors.passwordDoesNotMatch"
  ),
});

export const SignInSchema = yup.object().shape({
  login: RequiredSchema,
  password: RequiredSchema,
});
